"use server";

import {
  addVehicleModelSchema,
  editVehicleModelSchema,
  deleteVehicleModelSchema,
} from "@/lib/schemas/vehicle-models";
import { validateParams } from "@/lib/utils";
import { prisma } from "@/prisma";
import z from "zod";
import { requireServerRole } from "@/lib/guards";
import { GRP_ROLE_ADMIN } from "@/lib/grp";
import { ActionResult } from "@/types/server-action";

export async function deleteVehicleModel(
  params: z.infer<typeof deleteVehicleModelSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const { id } = validateParams(deleteVehicleModelSchema, params);

    await prisma.vehicleModel.update({
      where: { id },
      data: { deletedAt: new Date() },
    });

    return { success: true };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}

export async function addVehicleModel(
  params: z.infer<typeof addVehicleModelSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const { name, brandId } = validateParams(addVehicleModelSchema, params);

    const vehicleModel = await prisma.vehicleModel.create({
      data: { name, brandId, isActive: true },
    });

    return { success: true, data: vehicleModel };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}

export async function editVehicleModel(
  params: z.infer<typeof editVehicleModelSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const {
      id = -1,
      name,
      brandId,
      isActive = true,
    } = validateParams(editVehicleModelSchema, params);
    const vehicleModel = await prisma.vehicleModel.update({
      where: { id },
      data: { name, brandId, isActive },
    });

    return { success: true, data: vehicleModel };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}
